
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'data-privacy-request-ui',
  currentProjectVersion: 'static-1.5631',
  depVersions: {
  "data-privacy-request-ui": "static-1.5631",
  "data-fetching-client": "static-1.9774",
  "head-dlb": "static-1.5007",
  "hs-test-utils": "static-1.8133",
  "hub-http-shared-msw-handlers": "static-1.10241",
  "hubspot-dlb": "static-2.1854",
  "HubStyleTokens": "static-2.11588",
  "I18n": "static-7.1638",
  "jasmine-runner": "static-1.6571",
  "privacy-center-public-service-types": "static-1.4894",
  "quartz": "static-1.7171",
  "react-dlb": "static-1.81",
  "ui-components-test-utils": "static-1.5725",
  "UIComponents": "static-3.8534",
  "webpack-env": "static-1.54",
  "apollo-stack-hubspot": "static-3.87",
  "foundations-assets": "static-1.4985",
  "foundations-components": "static-1.8150",
  "foundations-components-test-utils": "static-1.5633",
  "foundations-theming": "static-1.4544",
  "hub-http": "static-1.6335",
  "quartz-config": "static-1.949",
  "quartz-core": "static-1.6390",
  "quartz-routing": "static-1.601",
  "quick-fetch": "static-1.3999",
  "raven": "static-3.5925",
  "react": "static-7.187",
  "react-rhumb": "static-1.16796",
  "SharedI18nStrings": "static-1.182",
  "ui-addon-i18n": "static-1.11261",
  "usage-tracker": "static-1.7461",
  "usage-tracker-anonymous": "static-1.5878",
  "usage-tracker-core": "static-1.7311",
  "enviro": "static-4.455",
  "hs-promise-rejection-tracking": "static-1.5587",
  "PortalIdParser": "static-2.404",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "hubspot-url-utils": "static-1.4132",
  "immutable": "static-2.79",
  "metrics-js": "static-1.9637",
  "react-redux": "static-7.71",
  "redux": "static-4.16",
  "styled-components": "static-2.89",
  "bend-plugin-trellis-migration": "static-1.3479",
  "moment": "static-3.26",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.3448",
  "quartz-webpack": "static-1.3395",
  "bend-plugin-quartz-routing": "static-1.249",
  "fast-json-stable-stringify": "static-1.4",
  "graphql": "static-1.83",
  "HeadJS": "static-2.769",
  "framer-motion": "static-1.73",
  "hs-test-utils-bend-plugin": "static-1.3244",
  "msw": "static-1.39",
  "testing-library": "static-1.153",
  "ts-schema": "static-1.4162",
  "i18n-data": "static-1.223",
  "moment-timezone": "static-5.84",
  "react-utils": "static-2.5424",
  "StyleGuideUI": "static-3.489",
  "jasmine": "static-4.4438",
  "rpc-client-utils": "static-1.4769",
  "HubStyle": "static-2.11895",
  "ui-addon-draggable": "static-3.4872",
  "cssUtils": "static-1.824",
  "hs-story-utils": "static-1.9535",
  "icons": "static-2.653",
  "react-create-root-preference": "static-1.35",
  "react-select-plus": "static-1.106",
  "react-virtualized": "static-2.100",
  "ui-images": "static-2.1180",
  "bend-plugin-foundations-components": "static-1.4419",
  "floating-ui": "static-1.58",
  "foundations-theming-specialty": "static-1.2260",
  "react-aria": "static-1.67",
  "tanstack-table": "static-1.56",
  "trellis-assets": "static-1.2189",
  "ui-fonts": "static-1.850",
  "foundations-components-legacy": "static-1.1175",
  "bend-plugin-foundations-theming": "static-1.3027",
  "foundations-theming-base": "static-1.3529",
  "stylex": "static-1.35",
  "hs-locale-management": "static-1.163",
  "dispatcher": "static-1.138",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.845",
  "hubspotter-http": "static-1.4733",
  "mobile-manifest-mixins": "static-1.544",
  "module-federation": "static-1.27",
  "quartz-auth": "static-1.846",
  "quartz-head": "static-1.836",
  "quartz-i18n": "static-1.846",
  "quartz-test": "static-1.846",
  "quartz-tracking": "static-1.550",
  "trellis-components": "static-1.2208",
  "usage-tracker-container": "static-1.7451",
  "csstype": "static-1.50",
  "web-vitals": "static-1.7",
  "react-input-autosize": "static-2.17",
  "bender-build-tools": "static-1.3281",
  "bend-plugin-chirp-manifest": "static-1.179",
  "chirp-fetch": "static-1.1999",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "react-flip-move": "static-1.72",
  "sassPrefix": "static-1.158",
  "hubspotter-http-shared-msw-handlers": "static-1.10239",
  "usage-tracker-session-replay": "static-1.5147",
  "base-ui": "static-1.13",
  "react-day-picker": "static-1.4",
  "trellis-theming": "static-1.1054",
  "tanstack-virtual": "static-1.31",
  "amplitude-session-replay-browser": "static-1.60"
},
  depPathPrefixes: {
  "data-privacy-request-ui": "/data-privacy-request-ui/static-1.5631",
  "data-fetching-client": "/data-fetching-client/static-1.9774",
  "head-dlb": "/head-dlb/static-1.5007",
  "hs-test-utils": "/hs-test-utils/static-1.8133",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10241",
  "hubspot-dlb": "/hubspot-dlb/static-2.1854",
  "HubStyleTokens": "/HubStyleTokens/static-2.11588",
  "I18n": "/I18n/static-7.1638",
  "jasmine-runner": "/jasmine-runner/static-1.6571",
  "privacy-center-public-service-types": "/privacy-center-public-service-types/static-1.4894",
  "quartz": "/quartz/static-1.7171",
  "react-dlb": "/react-dlb/static-1.81",
  "ui-components-test-utils": "/ui-components-test-utils/static-1.5725",
  "UIComponents": "/UIComponents/static-3.8534",
  "webpack-env": "/webpack-env/static-1.54",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.87",
  "foundations-assets": "/foundations-assets/static-1.4985",
  "foundations-components": "/foundations-components/static-1.8150",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5633",
  "foundations-theming": "/foundations-theming/static-1.4544",
  "hub-http": "/hub-http/static-1.6335",
  "quartz-config": "/quartz-config/static-1.949",
  "quartz-core": "/quartz-core/static-1.6390",
  "quartz-routing": "/quartz-routing/static-1.601",
  "quick-fetch": "/quick-fetch/static-1.3999",
  "raven": "/raven/static-3.5925",
  "react": "/react/static-7.187",
  "react-rhumb": "/react-rhumb/static-1.16796",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11261",
  "usage-tracker": "/usage-tracker/static-1.7461",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.5878",
  "usage-tracker-core": "/usage-tracker-core/static-1.7311",
  "enviro": "/enviro/static-4.455",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4132",
  "immutable": "/immutable/static-2.79",
  "metrics-js": "/metrics-js/static-1.9637",
  "react-redux": "/react-redux/static-7.71",
  "redux": "/redux/static-4.16",
  "styled-components": "/styled-components/static-2.89",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3479",
  "moment": "/moment/static-3.26",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3448",
  "quartz-webpack": "/quartz-webpack/static-1.3395",
  "bend-plugin-quartz-routing": "/bend-plugin-quartz-routing/static-1.249",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "graphql": "/graphql/static-1.83",
  "HeadJS": "/HeadJS/static-2.769",
  "framer-motion": "/framer-motion/static-1.73",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3244",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.153",
  "ts-schema": "/ts-schema/static-1.4162",
  "i18n-data": "/i18n-data/static-1.223",
  "moment-timezone": "/moment-timezone/static-5.84",
  "react-utils": "/react-utils/static-2.5424",
  "StyleGuideUI": "/StyleGuideUI/static-3.489",
  "jasmine": "/jasmine/static-4.4438",
  "rpc-client-utils": "/rpc-client-utils/static-1.4769",
  "HubStyle": "/HubStyle/static-2.11895",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4872",
  "cssUtils": "/cssUtils/static-1.824",
  "hs-story-utils": "/hs-story-utils/static-1.9535",
  "icons": "/icons/static-2.653",
  "react-create-root-preference": "/react-create-root-preference/static-1.35",
  "react-select-plus": "/react-select-plus/static-1.106",
  "react-virtualized": "/react-virtualized/static-2.100",
  "ui-images": "/ui-images/static-2.1180",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4419",
  "floating-ui": "/floating-ui/static-1.58",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2260",
  "react-aria": "/react-aria/static-1.67",
  "tanstack-table": "/tanstack-table/static-1.56",
  "trellis-assets": "/trellis-assets/static-1.2189",
  "ui-fonts": "/ui-fonts/static-1.850",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1175",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3027",
  "foundations-theming-base": "/foundations-theming-base/static-1.3529",
  "stylex": "/stylex/static-1.35",
  "hs-locale-management": "/hs-locale-management/static-1.163",
  "dispatcher": "/dispatcher/static-1.138",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.845",
  "hubspotter-http": "/hubspotter-http/static-1.4733",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.544",
  "module-federation": "/module-federation/static-1.27",
  "quartz-auth": "/quartz-auth/static-1.846",
  "quartz-head": "/quartz-head/static-1.836",
  "quartz-i18n": "/quartz-i18n/static-1.846",
  "quartz-test": "/quartz-test/static-1.846",
  "quartz-tracking": "/quartz-tracking/static-1.550",
  "trellis-components": "/trellis-components/static-1.2208",
  "usage-tracker-container": "/usage-tracker-container/static-1.7451",
  "csstype": "/csstype/static-1.50",
  "web-vitals": "/web-vitals/static-1.7",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "bender-build-tools": "/bender-build-tools/static-1.3281",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.179",
  "chirp-fetch": "/chirp-fetch/static-1.1999",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "react-flip-move": "/react-flip-move/static-1.72",
  "sassPrefix": "/sassPrefix/static-1.158",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10239",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5147",
  "base-ui": "/base-ui/static-1.13",
  "react-day-picker": "/react-day-picker/static-1.4",
  "trellis-theming": "/trellis-theming/static-1.1054",
  "tanstack-virtual": "/tanstack-virtual/static-1.31",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60"
}
};
